import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAddTransition = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "#4A5666",
		fillRule: "nonzero",
		children: /* @__PURE__ */ _jsx("path", { d: "M2.147 19.184A21.28 21.28 0 0 1 14.358 4.882L15.43 8.18l5.3-6.234L12.776.017l1.056 3.252C7.374 6.006 2.338 11.604.509 18.766a.845.845 0 0 0 1.638.418M15.733 11v2.75h2.75v1.5h-2.75V18h-1.5v-2.75h-2.75v-1.5h2.75V11z" })
	})
});
export default SvgAddTransition;
